export default {
    routes: [
        {
            // Moved into Settings ▸ Usage and billing; see `billing.js` for why
            // the old address survives, and why the redirect is a function.
            path: 'usage',
            redirect: to => ({ name: 'settings-billing-usage', query: to.query })
        }
    ]
};
